import type { TranslatedString } from "../types"

/**
 * Bilingual UI labels (Irish + English) surfaced around the site to teach vocabulary in context.
 * Render Irish first, e.g. `Teanga / Language`, mirroring how the read-more link references i18n.
 */
export const labels = {
  language: { translation: "Teanga", text: "Language" },
  translation: { translation: "Aistriúchán", text: "Translation" },
  pronunciation: { translation: "Fuaimniú", text: "Pronunciation" },
  summary: { translation: "Achoimre", text: "Summary" },
  examples: { translation: "Samplaí", text: "Examples" },
} as const satisfies Record<string, TranslatedString>

export type LabelKey = keyof typeof labels
